module.exports = __webpack_public_path__ + "07f5fabf6ceeb6cae46f65ace435b5d4.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/hat-1-s.png
// module id = 2236
// module chunks = 0